<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">Location Breakdown</h3>
    </div>
    <div class="panel-body" v-if="!bySchool || bySchool.length === 0">
      <p class="text-muted">No locations selected.</p>
    </div>
    <div v-else class="table-responsive">
      <table class="table table-striped table-hover" data-testid="franchise-location-breakdown">
        <thead>
          <tr>
            <th v-for="col in columns" :key="col.key" style="cursor: pointer;" @click="sortByColumn(col.key)">
              {{ col.label }}
              <CalculationTooltip v-if="col.tooltip" :text="col.tooltip" />
              <span v-if="sortKey === col.key">
                <i :class="sortAsc ? 'fa fa-sort-asc' : 'fa fa-sort-desc'"></i>
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in sortedRows" :key="row.school_id">
            <td>{{ row.school_name }}</td>
            <td>{{ inDollars(row.total_revenue) }}</td>
            <td>{{ row.total_orders.toLocaleString() }}</td>
            <td>{{ inDollars(row.average_order_value) }}</td>
            <td>{{ inDollars(row.previous_total_revenue) }}</td>
            <td :class="changeClass(row.revenue_change_percent)">{{ formatChange(row.revenue_change_percent, row.total_revenue) }}</td>
            <td :class="changeClass(row.orders_change_percent)">{{ formatChange(row.orders_change_percent, row.total_orders) }}</td>
            <td>{{ row.share_of_revenue_percent }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';
import { inDollars } from '../../../../DriveScout/Billing/Teller';

export default {
  name: 'SchoolBreakdownTable',
  components: { CalculationTooltip },
  props: {
    bySchool: { type: Array, required: true }
  },
  data: function() {
    return {
      sortKey: 'total_revenue',
      sortAsc: false
    };
  },
  computed: {
    columns: function() {
      return [
        { key: 'school_name', label: 'Location', tooltip: null },
        { key: 'total_revenue', label: 'Revenue', tooltip: 'Total of completed orders in the selected dates.' },
        { key: 'total_orders', label: 'Orders', tooltip: 'Number of completed orders.' },
        { key: 'average_order_value', label: 'Avg Order', tooltip: 'Revenue divided by orders.' },
        { key: 'previous_total_revenue', label: 'Previous Revenue', tooltip: 'Revenue in the comparison period.' },
        { key: 'revenue_change_percent', label: 'Revenue Change', tooltip: 'Change in revenue against the comparison period.' },
        { key: 'orders_change_percent', label: 'Orders Change', tooltip: 'Change in order count against the comparison period.' },
        { key: 'share_of_revenue_percent', label: 'Share', tooltip: 'This location\'s share of revenue across the selected locations.' }
      ];
    },
    sortedRows: function() {
      var key = this.sortKey;
      var direction = this.sortAsc ? 1 : -1;
      return this.bySchool.slice().sort(function(left, right) {
        var leftValue = left[key];
        var rightValue = right[key];
        // No comparison (null) sorts after every number, whichever way the column runs
        if (leftValue === null || rightValue === null) {
          return (leftValue === null) - (rightValue === null);
        }
        if (leftValue < rightValue) return -direction;
        if (leftValue > rightValue) return direction;
        return 0;
      });
    }
  },
  methods: {
    inDollars: inDollars,
    sortByColumn: function(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = key === 'school_name';
      }
    },
    formatChange: function(percent, currentValue) {
      if (percent === null) {
        return currentValue > 0 ? 'New' : '–';
      }
      return (percent >= 0 ? '+' : '') + percent + '%';
    },
    changeClass: function(percent) {
      if (percent === null) return 'text-muted';
      return percent >= 0 ? 'text-success' : 'text-danger';
    }
  }
};
</script>
